/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ThemeDark({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeWidth={1.4} d="m13.155 11.285.158-.682-.158.682a.82.82 0 0 1 .523.378c.041.076.051.137.049.178a.24.24 0 0 1-.062.142A6.901 6.901 0 1 1 6.973.86l.004.005a.23.23 0 0 1 .028.185 8.3 8.3 0 0 0 6.15 10.235Z" /></svg>;
}
;